import axios from '../axios'
import { ApiController } from './types'

const base = '/jobs'

const apiController: ApiController = {
  updateJob: async (jobId: string, request) =>
    await axios
      .patch(`${base}/${jobId}`, request)
      .then((response) => response.data),
}

export default apiController
